var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgDropbox = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6895_36702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.28394 0.279297L1.15527 2.2696L4.28394 4.2599L7.41391 2.2696L10.5439 4.2599L13.6734 2.2696L10.5439 0.279297L7.41391 2.2696L4.28437 0.279297H4.28394ZM4.28394 8.2405L1.15527 6.25063L4.28394 4.2599L7.41391 6.2502L4.28394 8.2405ZM7.41434 6.25063L10.5439 4.2599L13.6738 6.2502L10.5439 8.2405L7.41391 6.2502L7.41434 6.25063ZM7.41434 10.8942L4.28437 8.90393L7.41434 6.91363L10.5443 8.90393L7.41434 10.8942Z",
    fill: "#D1D2D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6895_36702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 10.8333,
    fill: "white",
    transform: "translate(0.947266 0.140625)"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgDropbox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dropbox.c3a5588920761a659be155fd1a1a4890.svg";